import React, { useEffect } from 'react'
import "./footerLight.css"
import FooterLogo from "../../assets/images/Dlogo.png"
import { FaWhatsapp, FaInstagram, FaYoutube, FaFacebookF } from "react-icons/fa";
import { FaXTwitter, FaTiktok } from "react-icons/fa6";


const FooterLight = () => {
    
    return (
        <>
            <footer className="footerLight">
                <div className="container-fluid containerSpacing">
                    <div className="row">
                        <div className="col-12">
                            <div className="logobox">
                                <a className='footerLogo' data-aos-easing="ease-in-out" data-aos="fade-up" href="/">
                                    <img src={FooterLogo} alt="Logo" />
                                </a>
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="social-box" data-aos-easing="ease-in-out" data-aos="fade-right">
                                <ul>
                                    <li>
                                        <a href="">
                                            <FaWhatsapp />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="">
                                            <FaInstagram />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="">
                                            <FaXTwitter />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="">
                                            <FaYoutube />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="">
                                            <FaTiktok />
                                        </a>
                                    </li>
                                    <li>
                                        <a href="">
                                            <FaFacebookF />
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    )
}

export default FooterLight